@if (planttyper && allatradslag) {
<div class="row mx-0">
    @if(skogsvardTradslagPlantaLista?.length > 0){
    <div class="tradslag-planta-list">
        @for(skogsvardTradslagPlanta of skogsvardTradslagPlantaLista; track skogsvardTradslagPlanta){
        <rask-skogsvard-tradslag-plantor-row
            class="d-block"
            [skogsvardTradslagPlantaLista]="skogsvardTradslagPlantaLista"
            [kontraktReadonly]="kontraktReadonly"
            (deleted)="deleted($event)"
            [skogsvardTradslagPlanta]="skogsvardTradslagPlanta"
            [allatradslag]="allatradslag"
            [planttyper]="planttyper">
        </rask-skogsvard-tradslag-plantor-row>
        }
    </div>
    }
    <div class="col-12">
        <div class="pb-2 pt-4">
            <rask-action-button icon="fas fa-plus"
                [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly || (isWorking$ | async) || (isVacsAvraknat$ | async)"
                (click)="addRow()" class="float-start tradslag-lagg-till">Lägg till trädslag</rask-action-button>
        </div>
    </div>
</div>
}